// src/components/games/GameSystemRequirement.js
import { useState } from "react";

function GameSystemRequirement({ requirements = { minimum: {}, recommended: {} } }) {
  const [showRecommended, setShowRecommended] = useState(false);

  // 고정된 순서
  const fixedOrder = ["OS", "CPU", "RAM", "GPU","저장공간","기타"];

  const renderSpecTable = (specs = {}) => {
    // 1) fixedOrder에 있는 키만, specs에 실제 값이 있는 것만
    const primaryKeys = fixedOrder.filter((k) => k in specs);
    // 2) fixedOrder에 없거나, 값이 없더라도 모든 나머지 키
    const otherKeys = Object.keys(specs).filter((k) => !fixedOrder.includes(k));

    const rows = [...primaryKeys, ...otherKeys];

    return (
      <table className="w-full table-fixed border-collapse text-sm text-left text-gray-300 mt-2">
        <colgroup>
          <col className="w-28" />
          <col />
        </colgroup>
        <tbody>
          {rows.length > 0 ? (
            rows.map((key) => (
              <tr key={key} className="align-top">
                <td className="py-1 pr-4 text-gray-400 whitespace-nowrap">{key}</td>
                <td className="py-1 whitespace-normal break-words">
                  {specs[key] || "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2} className="py-1 text-gray-500">
                정보 없음
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  };

  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-3">🖥️ 시스템 요구 사항</h4>

      <div>
        <h5 className="text-white font-semibold border-b border-gray-600 pb-1">
          최소 사양
        </h5>
        {renderSpecTable(requirements.minimum)}
      </div>

      <div className="mt-4">
        <div className="flex justify-between items-center border-b border-gray-600 pb-1">
          <h5 className="text-white font-semibold">권장 사양</h5>
          <button
            onClick={() => setShowRecommended(!showRecommended)}
            className="text-gray-400 text-sm hover:text-white transition"
          >
            {showRecommended ? "▲ 닫기" : "▼ 열기"}
          </button>
        </div>
        {showRecommended && renderSpecTable(requirements.recommended)}
      </div>
    </div>
  );
}

export default GameSystemRequirement;
